import {Injectable} from '@angular/core';
import {WizardNestedFormService} from '../abstract/wizard-nested-form-service';
import {FormBuilder, Validators} from '@angular/forms';
import {WizardValidators} from '../../wizard-validators';

@Injectable()
export class OrganizationContactsService extends WizardNestedFormService {
    form = this.fb.group({
        _touched: [false, Validators.requiredTrue],

        /**
         * Юридический адрес
         */
        legal_address_city_id: ['', WizardValidators.required('Город')],
        legal_address_city: ['', WizardValidators.required('Город')],
        legal_address_index: ['', WizardValidators.index()],
        legal_address: ['', WizardValidators.required('Юридический адрес')],

        /**
         * Почтовый адрес
         */
        postal_address_city_id: ['', WizardValidators.required('Город')],
        postal_address_city: ['', WizardValidators.required('Город')],
        postal_address_index: ['', WizardValidators.index()],
        postal_address: ['', WizardValidators.required('Почтовый адрес')],

        /**
         * Фактический адрес
         */
        physical_address_city_id: ['', WizardValidators.required('Город')],
        physical_address_city: ['', WizardValidators.required('Город')],
        physical_address_index: ['', WizardValidators.index()],
        physical_address: ['', WizardValidators.required('Фактический адрес')],

        phone: ['', [
            WizardValidators.required('Телефон'),
        ]],

        email: ['', [
            WizardValidators.required('Электронная почта'),
            WizardValidators.email(),
        ]],
    });

    constructor(
        private fb: FormBuilder,
    ) {
        super();
    }
}
